import { chartTypes } from '../../config/chartTypeConfig';

const ChartTypeSelector = ({
  selectedType,
  onTypeChange,
  showBreakdown,
}) => {
  // Filter chart types based on breakdown mode
  const availableTypes = Object.entries(chartTypes).filter(([, config]) => {
    if (showBreakdown) {
      return config.supportsBreakdown;
    } else {
      return config.supportsSummary;
    }
  });

  return (
    <div className="flex items-center space-x-1" data-intro="chart-type-selector">
      <span className="hidden sm:block text-sm font-medium text-gray-700 dark:text-gray-300 mr-2">
        Chart:
      </span>
      <div className="inline-flex rounded-lg border border-gray-200 dark:border-gray-600 bg-gray-100 dark:bg-gray-700 p-1">
        {availableTypes.map(([type, config]) => (
          <button
            key={type}
            onClick={() => onTypeChange(type)}
            title={config.label}
            className={`p-2 rounded-md transition-colors ${
              selectedType === type
                ? 'bg-white dark:bg-gray-800 text-blue-600 dark:text-blue-400 shadow-sm'
                : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 hover:bg-white/50 dark:hover:bg-gray-800/50'
            }`}
          >
            {config.icon}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ChartTypeSelector;
